import { render } from "./TanaoroshiSaiPage.vue?vue&type=template&id=7828eb72"
import script from "./TanaoroshiSaiPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiSaiPage.vue?vue&type=script&lang=js"

import "./TanaoroshiSaiPage.vue?vue&type=style&index=0&id=7828eb72&lang=css"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__